import React, {FC} from 'react';
import styles from './ConfirmLogout.module.css';
import {IConfirmLogout} from "../../../../declarations/types";
import {doneSvg} from "../../../../utils/constants";

export const ConfirmLogout: FC<IConfirmLogout> = ({
  setOpenConfirmLogout,
  onLogout,
}) => {

  const onCloseConfirmModal = () => {
    if (setOpenConfirmLogout) {
      setOpenConfirmLogout(false);
    }
  };

  return (
    <div className={styles.confirmLogout}>
      <div className={styles.content}>
        <img src={doneSvg} alt="" className={styles.contentIcon} />
        <h2 className={styles.title}>
          Вы уверены, что хотите выйти?
        </h2>
        <div className={styles.action}>
          <button type="button" onClick={() => onLogout()} className={styles.contentBtn}>
            Да
          </button>
          <button type="button" onClick={onCloseConfirmModal} className={styles.contentBtn}>
            Нет
          </button>
        </div>
      </div>
    </div>
  );
};
